define(["require", "exports", "tslib", "./BootstrapEnvironment", "./BootstrapManager"], function (require, exports, tslib_1, BootstrapEnvironment_1, BootstrapManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initializer = void 0;
    function initializer(configDev, configTest, configHuidu, configProd, envConfig, i18n, vueObj) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var env;
            return (0, tslib_1.__generator)(this, function (_a) {
                env = (0, BootstrapEnvironment_1.getEnvironment)(configDev, configTest, configHuidu, configProd, envConfig);
                BootstrapManager_1.bootStrapManager.setConfig(env, i18n, vueObj);
                return [2, env];
            });
        });
    }
    exports.initializer = initializer;
});
//# sourceMappingURL=Bootstrap.js.map